import { getPlayerFullPhone } from '@/modules/manage-player/api/services'
import { useMutation } from '@tanstack/react-query'

export function useMutationGetPlayerFullPhone() {
	return useMutation({
		mutationFn: (playerId: string) => getPlayerFullPhone(playerId),
	})
}
